var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmtp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95703 9.55652L1.23047 14.5523L8.27703 23.4609L7.95703 9.55652Z",
    fill: "#68544F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0429 9.55652L33.7229 23.4609L40.7695 14.5523L34.0429 9.55652Z",
    fill: "#53433F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5352 1.23047V31.459C34.5352 32.1481 33.9938 32.6895 33.3047 32.6895H8.69531C8.00617 32.6895 7.46484 32.1481 7.46484 31.459V1.23047C7.46484 0.541324 8.00617 0 8.69531 0H33.3047C33.9938 0 34.5352 0.541324 34.5352 1.23047Z",
    fill: "#F7F0EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5352 1.23047V31.459C34.5352 32.1481 33.9938 32.6895 33.3047 32.6895H21V0H33.3047C33.9938 0 34.5352 0.541324 34.5352 1.23047Z",
    fill: "#EFE2DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6133 8.69531C29.6133 9.38446 29.072 9.92578 28.3828 9.92578H13.6172C12.928 9.92578 12.3867 9.38446 12.3867 8.69531C12.3867 8.00617 12.928 7.46484 13.6172 7.46484H28.3828C29.072 7.46484 29.6133 8.00617 29.6133 8.69531Z",
    fill: "#E1D3CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6133 13.6172C29.6133 14.3063 29.072 14.8477 28.3828 14.8477H13.6172C12.928 14.8477 12.3867 14.3063 12.3867 13.6172C12.3867 12.928 12.928 12.3867 13.6172 12.3867H28.3828C29.072 12.3867 29.6133 12.928 29.6133 13.6172Z",
    fill: "#E1D3CE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2305 18.5391C22.2305 19.2282 21.6891 19.7695 21 19.7695H13.6172C12.928 19.7695 12.3867 19.2282 12.3867 18.5391C12.3867 17.8499 12.928 17.3086 13.6172 17.3086H21C21.6891 17.3086 22.2305 17.8499 22.2305 18.5391Z",
    fill: "#E1D3CE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.7695V17.3086C21.6891 17.3086 22.2305 17.8499 22.2305 18.5391C22.2305 19.2282 21.6891 19.7695 21 19.7695Z",
    fill: "#CDBFBA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3828 14.8477H21V12.3867H28.3828C29.072 12.3867 29.6133 12.928 29.6133 13.6172C29.6133 14.3063 29.072 14.8477 28.3828 14.8477Z",
    fill: "#CDBFBA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3828 9.92578H21V7.46484H28.3828C29.072 7.46484 29.6133 8.00617 29.6133 8.69531C29.6133 9.38446 29.072 9.92578 28.3828 9.92578Z",
    fill: "#CDBFBA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.557 15.143C41.5324 15.143 40.7695 14.5524 40.7695 14.5524L38.7269 16.0781L21.7383 28.7521C21.5169 28.9242 21.2461 29.0228 21 29.0228C20.7539 29.0228 20.4831 28.9242 20.2617 28.7521L3.27313 16.0781L1.23047 14.5524C1.23047 14.5524 0.467578 15.143 0.442969 15.143C0.172266 15.3646 0 15.7089 0 16.0781V38.3086C0 40.3513 1.64875 42 3.69141 42H38.3086C40.3513 42 42 40.3513 42 38.3086V16.0781C42 15.7089 41.8277 15.3646 41.557 15.143Z",
    fill: "#FDBF00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42 16.0781V38.3086C42 40.3513 40.3513 42 38.3086 42H21V29.0227C21.246 29.0227 21.5169 28.9242 21.7383 28.752L38.7269 16.0781L40.7695 14.5524C40.7695 14.5524 41.5324 15.143 41.557 15.143C41.8277 15.3646 42 15.7089 42 16.0781Z",
    fill: "#FF9F00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmtp);
export default __webpack_public_path__ + "static/media/Smtp.974f87433d649ffcbcc4ba762aba6e50.svg";
export { ForwardRef as ReactComponent };